import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledResumeIcon = styled(StyledFlex)`
   cursor: pointer;
`;

StyledResumeIcon.displayName = 'StyledResumeIcon';
